import { combineReducers } from '@reduxjs/toolkit';

// Must resolve after the persisted reducers below: persistedAuthReducer pulls in
// authSlice, which resolves the baseApi<->authSlice circular import through its
// safe direction. Importing baseApi first instead makes authApi.js hit `baseApi`
// before its own initialization (TDZ) — see the same note in store.js.
/* eslint-disable import/order */
import { persistedActiveContextReducer } from './persistedActiveContextReducer';
import { persistedAuthReducer } from './persistedAuthReducer';
import { persistedLanguageReducer } from './persistedLanguageReducer';
import { persistedSensitiveDataReducer } from './persistedSensitiveDataReducer';
import { persistedSidebarReducer } from './persistedSidebarReducer';
import { persistedUserReducer } from './persistedUserReducer';

import { baseApi } from '@shared/api/baseApi.js';
/* eslint-enable import/order */

export const rootReducers = combineReducers({
	[baseApi.reducerPath]: baseApi.reducer,
	auth: persistedAuthReducer,
	user: persistedUserReducer,
	activeContext: persistedActiveContextReducer,
	language: persistedLanguageReducer,
	sidebar: persistedSidebarReducer,
	sensitiveData: persistedSensitiveDataReducer,
});
